import React from "react";
import { NO_DATA } from "../../../assets";

function CRM() {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[calc(100vh-80px)]">
      <img src={NO_DATA} alt="No data" className="w-[160px] h-[160px] mb-6" />
      <p className="text-[#111827] text-base mb-4">
        Continue to the Chief Registrar Module
      </p>
      <button
        type="button"
        className="px-10 py-2.5 rounded-lg bg-[#00B074] text-white text-sm font-semibold shadow-sm"
      >
        Continue
      </button>
    </div>
  );
}

export default CRM;
